import { render, staticRenderFns } from "./course-usecar.vue?vue&type=template&id=73837190&scoped=true&"
import script from "./course-usecar.vue?vue&type=script&lang=js&"
export * from "./course-usecar.vue?vue&type=script&lang=js&"
import style0 from "./course-usecar.vue?vue&type=style&index=0&id=73837190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73837190",
  null
  
)

export default component.exports